<section class="register-header">
    <div class="container-fluid">
        <div class="row">
            <div class="register-logo">
                <img src="./assets/images/logo-main.png" alt = "smiONE logo">
            </div>
        </div>
    </div>
</section>

<div [ngClass]="flow !=='Enroll' ? 'registration bg-white': 'defaultp'">
    <div>
        <img src="assets/images/register/grey-circle-graphic.png" srcset="assets/images/register/grey-circle-graphic@2x.png 2x,
            assets/images/register/grey-circle-graphic@3x.png 3x" class="grey-circle-graphic" alt = "Graphic circle">
    </div>

    <section *ngIf="flow === 'Enroll'" id="enrollment_banner">
        <div class="enrollment-overlay"></div>
        <svg width="100%" height="100%" viewBox="0 0 1440 316" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
            <g id="Product-Header" transform="translate(-1 0)">
              <path d="M0 0L1443 0L1443 311L0 311L0 0Z" id="Mask" fill="#fff" fill-rule="evenodd" stroke="" />
              <g clip-path="url(#mask_1)">
                <g id="Group-10" transform="matrix(0.9998477 0.017452406 -0.017452406 0.9998477 -671.3154 -63.353207)">
                  <path d="M0 96.2268C194.012 57.9948 430.769 91.5043 633.841 63.3587C765.102 45.1666 866.271 7.79028 1003.32 1.30978C1128.62 -4.61528 1265.83 11.0515 1390.67 18.5756C1600.5 31.2216 1817.36 101.725 2002.18 57.0422L2004.39 247.757L0.0032959 247.752L0 96.2268Z" transform="matrix(0.9975641 -0.06975647 -0.06975647 -0.9975641 17.521795 388.61783)" id="Fill-61" fill="none" fill-rule="evenodd" stroke="#2E70FD" stroke-width="2" />
                  <path d="M0.0310059 55.576C87.439 29.2855 193.473 29.4066 292.327 37.0926C391.183 44.7793 488.819 59.3389 588.679 59.5709C792.263 60.0424 984.032 1.16309 1187.61 0.0171814C1302.54 -0.630249 1414.71 17.1876 1528.02 27.6583C1641.34 38.1289 1763.51 40.5581 1865.31 11.5056L1865.3 294.984L0 295.029L0.0310059 55.576Z" transform="matrix(0.99939084 -0.03489945 -0.03489945 -0.99939084 290.68015 364.58862)" id="Fill-8-Copy-2" fill="#00c188" fill-rule="evenodd" stroke="none" />
                  <path d="M0 107.817C184.425 75.4781 409.482 103.824 602.519 80.0171C727.294 64.6293 823.463 33.0139 953.738 27.5327C1072.85 22.5214 1203.28 35.774 1321.95 42.1389C1521.41 52.8368 1729.65 37.7957 1905.33 0L1905.34 236L17.1084 311.922L0 107.817Z" transform="matrix(-0.9998477 -0.017452458 0.017452458 -0.9998477 2499.5762 346.00626)" id="Fill-6 " fill="#F1F5FD" fill-rule="evenodd" stroke="none" />
                </g>
              </g>
            </g>
        </svg>

        <div class="enrollment_main">
            <div class="container-fluid">
                <div class="enrollment_flex">
                    <div class="enrollment_data">
                        <h3> {{'ENROLLMENT.STEP'+selectedStep?.step+'.Header' | translate}} </h3>
                    </div>
                    <div class="enrollment_data">
                        <div class="enrollment-step-container">
                            <div *ngFor="let step of getSteps()" class="step-details">
                                <span *ngIf="!step?.hide" class="step-mark"> <i class="fa" [ngClass]="selectedStep?.step > step.step ? 'fa-check' : ''"></i> </span>
                                <h6 *ngIf="!step?.hide"> {{step?.header}} </h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </section>
   
    <div class="container">
        <div *ngIf="flow === 'General'" class="row">
            <div class="sc-header">

                <div class="sc-heading" *ngIf="selectedStep?.name.indexOf('Step')=== -1" >
                    <h3 class="section-heading header-text" [ngStyle]="{'width': selectedStep?.hide ? '100%': ''}">{{selectedStep?.header}}</h3>
                    <div class="row header-sub-text" [ngStyle]="{'display': selectedStep?.subHeader ? '': 'none', 
                        'margin-left': selectedStep?.hide ? '0': '',
                        'margin-top': selectedStep?.hide ? '0': ''}">
                            {{selectedStep?.subHeader}}
                    </div>
                </div>
                <div class="sc-heading" *ngIf="selectedStep?.name.indexOf('Step')!== -1" >                  
                    <h3 class="section-heading header-text" [ngStyle]="{'width': selectedStep?.hide ? '100%': ''}">{{selectedStep?.header | translate}}</h3>
                    <div class="row header-sub-text" [ngStyle]="{'display': selectedStep?.subHeader ? '': 'none', 
                        'margin-left': selectedStep?.hide ? '0': '',
                        'margin-top': selectedStep?.hide ? '0': ''}">
                            {{selectedStep?.subHeader | translate}}
                    </div>
                </div>


                <div class="row step-container step-container-top-10" *ngIf="!selectedStep?.hide">
                    <div class="row" *ngFor="let step of getSteps()">
                        <div class="step" (click)="stepChanged(step)" [disabled]=""
                        [ngStyle]="{'cursor': step.canActivate ? 'pointer': ''}">
                            <div class="step-label"
                            [ngClass]="selectedStep?.step >= step.step ? 'step-label-highlight' : 'deactivated-step'"
                            >{{step.displayStep? step.displayStep : step.step}}</div>
                            <div class="step-text"  *ngIf="step?.name.indexOf('Step')=== -1" [ngClass]="{'step-text-highlight': selectedStep?.step >=step.step}">{{step.name}}</div>
                            <div class="step-text"  *ngIf="step?.name.indexOf('Step')!== -1" [ngClass]="{'step-text-highlight': selectedStep?.step >=step.step}">{{step.name | translate}}</div>
                        </div>
                        <div class="step-line" *ngIf="!step.hide && step.step < getSteps().length"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <section *ngIf="flow === 'Enroll'">
            <svg width="100%" height="100%" viewBox="0 0 1440 316" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
                <g id="Product-Header" transform="translate(-1 0)">
                  <path d="M0 0L1443 0L1443 311L0 311L0 0Z" id="Mask" fill="#ffffff" fill-rule="evenodd" stroke="" />
                  <g clip-path="url(#mask_1)">
                    <g id="Group-10" transform="matrix(0.9998477 0.017452406 -0.017452406 0.9998477 -671.3154 -63.353207)">
                      <path d="M0 96.2268C194.012 57.9948 430.769 91.5043 633.841 63.3587C765.102 45.1666 866.271 7.79028 1003.32 1.30978C1128.62 -4.61528 1265.83 11.0515 1390.67 18.5756C1600.5 31.2216 1817.36 101.725 2002.18 57.0422L2004.39 247.757L0.0032959 247.752L0 96.2268Z" transform="matrix(0.9975641 -0.06975647 -0.06975647 -0.9975641 17.521795 388.61783)" id="Fill-6" fill="none" fill-rule="evenodd" stroke="#2E70FD" stroke-width="2" />
                      <path d="M0.0310059 55.576C87.439 29.2855 193.473 29.4066 292.327 37.0926C391.183 44.7793 488.819 59.3389 588.679 59.5709C792.263 60.0424 984.032 1.16309 1187.61 0.0171814C1302.54 -0.630249 1414.71 17.1876 1528.02 27.6583C1641.34 38.1289 1763.51 40.5581 1865.31 11.5056L1865.3 294.984L0 295.029L0.0310059 55.576Z" transform="matrix(0.99939084 -0.03489945 -0.03489945 -0.99939084 290.68015 364.58862)" id="Fill-8-Copy-2" fill="var(--primary-color1)" fill-rule="evenodd" stroke="none" />
                      <path d="M0 107.817C184.425 75.4781 409.482 103.824 602.519 80.0171C727.294 64.6293 823.463 33.0139 953.738 27.5327C1072.85 22.5214 1203.28 35.774 1321.95 42.1389C1521.41 52.8368 1729.65 37.7957 1905.33 0L1905.34 236L17.1084 311.922L0 107.817Z" transform="matrix(-0.9998477 -0.017452458 0.017452458 -0.9998477 2499.5762 346.00626)" id="Fill-6 " fill="#F1F5FD" fill-rule="evenodd" stroke="none" />
                    </g>
                  </g>
                </g>
            </svg>
        </section> -->
        
        <ng-content select='.body'></ng-content>
        <div class="row" *ngIf="flow !=='Enroll'">
            <div class="col-md-12">
                <div class="register-footer register-footer-wave">
                    <div class="register-footer-wave-text">
                        <p> {{'DASHBOARD.FOOTER.Para1' | translate}} </p>
                        <div class="gap"> </div>  
                        <p> {{'DASHBOARD.FOOTER.Para2' | translate}} </p>
                        <!-- <div class="gap"> </div>   -->
                        <!-- <p> {{'DASHBOARD.FOOTER.Para3' | translate}} </p> -->
                    </div>
                </div>
            </div>
        </div> 
    </div>
</div>

<div class="register-footer p-0" *ngIf="flow !=='Enroll'">
    <img src="./assets/images/wave-module.png" width="100%" alt = "Footer wave">
</div>


<section *ngIf="flow === 'Enroll'" class="web-only-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="woc-para">
                    <p> {{'DASHBOARD.FOOTER.Para1' | translate}} </p>
                    <div class="gap"> </div>  
                    <p> {{'DASHBOARD.FOOTER.Para2' | translate}} </p>
                    <div class="gap"> </div>  
                    <p> {{'DASHBOARD.FOOTER.Para3' | translate}} </p>
                </div>
            </div>
        </div>
    </div>
</section>


<footer *ngIf="flow === 'Enroll'" role="group">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-4">
                <div class="footer-part footer-r-b">

                    <div class="footer-logo">
                        <h3>
                            <img src="./assets/images/logo-white.png" alt="Footer logo">
                        </h3>
                    </div>
                </div>
            </div>

            <div class="col-md-8">
                <div class="footer-part">                   
                    <span class="mt-10">
                        {{'DASHBOARD.FOOTER.Copright2020SIMOne' | translate}} <br/> {{'DASHBOARD.FOOTER.AllRightsReserved' | translate}}
                    </span>
                </div>
            </div>
        </div>
    </div>
</footer>